'use client';

import { c as _c } from "react/compiler-runtime";
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import { useState } from 'react';
import type { GetAllBookingsForMonthOutputDTO } from '@/backend/modules/phone-call-booking/endpoints/queries/get-all-bookings-for-month/output.dto';
import { Link } from '@/frontend/design-system/actions/Link';
import { Badge } from '@/frontend/design-system/data-display/Badge';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { Field, Label } from '@/frontend/design-system/forms/Fieldset';
import { Switch } from '@/frontend/design-system/forms/Switch';
import { Divider } from '@/frontend/design-system/layouts/Divider';
import { Caption } from '@/frontend/design-system/typography/Caption';
import { Label3 } from '@/frontend/design-system/typography/Label';
import { P2, P3 } from '@/frontend/design-system/typography/Paragraph';
import { cn } from '@/frontend/utils';
type CallBooking = GetAllBookingsForMonthOutputDTO['bookings'][number];
type PlannedCallCardProps = {
  booking: CallBooking;
  pastMeeting?: boolean;
};
export function PlannedCallCard(t0) {
  const $ = _c(54);
  const {
    booking,
    pastMeeting: t1
  } = t0;
  const pastMeeting = t1 === undefined ? false : t1;
  const [didNotShow, setDidNotShow] = useState(booking.client.didNotShow ?? false);
  const phoneNumber = booking.client.phoneNumber ?? "";
  const t2 = didNotShow && "border-borderError";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex flex-col gap-4 rounded-md p-4", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== pastMeeting) {
    t4 = !pastMeeting && <P2 className="hidden items-center gap-2 text-contentYellow"><InformationCircleIcon className="h-5 w-5" />Ta osoba już ... nie pojawiła się na spotkaniu</P2>;
    $[2] = pastMeeting;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = didNotShow && "text-contentRed";
  const t6 = pastMeeting && "opacity-50";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = cn(t5, t6);
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== booking.startTime) {
    t8 = format(booking.startTime, "HH:mm", {
      locale: pl
    });
    $[7] = booking.startTime;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = t8 + " " + (booking.client.fullname ?? "Brak podanego imienia i nazwiska klienta");
  const t10 = didNotShow && "text-contentRed";
  let t11;
  if ($[9] !== t10) {
    t11 = cn("ml-3 font-bold text-algoBlue", t10);
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const t12 = phoneNumber.slice(0, 3) + " " + phoneNumber.slice(3, 6) + " " + phoneNumber.slice(6, 9);
  let t13;
  if ($[11] !== t11 || $[12] !== t12) {
    t13 = <span className={t11}>+48{" "}{t12}</span>;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t13 || $[15] !== t7 || $[16] !== t9) {
    t14 = <div className="flex items-center justify-between"><P2 className={t7}>{t9}{t13}</P2></div>;
    $[14] = t13;
    $[15] = t7;
    $[16] = t9;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const t15 = pastMeeting && "opacity-50";
  let t16;
  if ($[18] !== t15) {
    t16 = cn("space-y-4", t15);
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Caption className="text-contentSecondary">Temat spotkania</Caption>;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== booking.mentoringDetails) {
    t18 = booking.mentoringDetails && <>{booking.mentoringDetails.advancedMentoringDetails ? <Badge color="greenInverted">Mentoring rozszerzony</Badge> : <Badge color="yellowInverted">Mentoring podstawowy</Badge>}{booking.mentoringDetails.subscription && <Badge color="blueInverted">Subskrypcja {booking.mentoringDetails.subscription}</Badge>}</>;
    $[21] = booking.mentoringDetails;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t18) {
    t19 = <div className="flex items-center gap-3">{t17}{t18}</div>;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== booking.client.message) {
    t20 = booking.client.message && <P3 className="text-contentSecondary">{booking.client.message}</P3>;
    $[25] = booking.client.message;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t16 || $[28] !== t19 || $[29] !== t20) {
    t21 = <div className={t16}>{t19}{t20}</div>;
    $[27] = t16;
    $[28] = t19;
    $[29] = t20;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== booking.scheduleId) {
    t22 = btoa(booking.scheduleId);
    $[31] = booking.scheduleId;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  const t23 = `/bezplatna-konsultacja/${t22}`;
  let t24;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Label3 className="text-algoBlue">Pokaż szczegóły</Label3>;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  let t25;
  if ($[34] !== t23) {
    t25 = <Link href={t23}>{t24}</Link>;
    $[34] = t23;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Divider />;
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = () => setDidNotShow(_temp);
    $[37] = t27;
  } else {
    t27 = $[37];
  }
  let t28;
  if ($[38] !== didNotShow) {
    t28 = <Switch checked={didNotShow} onChange={t27} />;
    $[38] = didNotShow;
    $[39] = t28;
  } else {
    t28 = $[39];
  }
  const t29 = didNotShow ? "text-contentRed" : "text-contentSecondary";
  let t30;
  if ($[40] !== t29) {
    t30 = cn(t29);
    $[40] = t29;
    $[41] = t30;
  } else {
    t30 = $[41];
  }
  let t31;
  if ($[42] !== t30) {
    t31 = <Label className={t30}>Użytkownik nie pojawił się na spotkaniu</Label>;
    $[42] = t30;
    $[43] = t31;
  } else {
    t31 = $[43];
  }
  let t32;
  if ($[44] !== t28 || $[45] !== t31) {
    t32 = <Field className="flex items-center gap-2">{t28}{t31}</Field>;
    $[44] = t28;
    $[45] = t31;
    $[46] = t32;
  } else {
    t32 = $[46];
  }
  let t33;
  if ($[47] !== t14 || $[48] !== t21 || $[49] !== t25 || $[50] !== t3 || $[51] !== t32 || $[52] !== t4) {
    t33 = <LightCard className={t3}>{t4}{t14}{t21}{t25}{t26}{t32}</LightCard>;
    $[47] = t14;
    $[48] = t21;
    $[49] = t25;
    $[50] = t3;
    $[51] = t32;
    $[52] = t4;
    $[53] = t33;
  } else {
    t33 = $[53];
  }
  return t33;
}
function _temp(prev) {
  return !prev;
}